<ng-container *ngIf="process$ | async as process">
  <div *ngIf="category?.isDescriptionStandardRequired">
    <mat-label class="font-weight-bold field-required d-inline-block mb-2">
      {{'forms.common.Description Standard' | translate}}
    </mat-label>
    <p-editor name="descriptionStandardResult" [style]="{'height':'200px'}" required
      [(ngModel)]="category.descriptionStandardResult" [readonly]="true">
    </p-editor>
  </div>

  <br/>
  <ng-container *ngFor="let optionalInput of category.optionalInputs">
    <mat-label class="font-weight-bold d-inline-block mb-2">
      {{optionalInput| propertyLocalized : ["nameAr", "nameEn"] | async}}
    </mat-label>
    <mat-list class="border rounded">
      <mat-list-item *ngFor="let item of optionalInput.results">
        <div class="w-100 d-flex justify-content-between">
          {{item.value}}
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
    </mat-list>
    <br/>
  </ng-container>
</ng-container>